import { render, staticRenderFns } from "./Variance.vue?vue&type=template&id=25886b88"
import script from "./Variance.vue?vue&type=script&lang=js"
export * from "./Variance.vue?vue&type=script&lang=js"
import style0 from "./Variance.vue?vue&type=style&index=0&id=25886b88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports